@if (messageType) {
  @if (messageType === 'ENDED_SESSION') {
    <p-message severity="success" [life]="5000" closable i18n>User session ended</p-message>
  } @else if (messageType === 'FAILED_TO_END_SESSION') {
    <p-message severity="error" closable i18n>An error occurred while trying to end user session!</p-message>
  } @else if (messageType === 'ACTION_REJECTED') {
    <p-message severity="info" [life]="5000" closable i18n>User session still active</p-message>
  }
}
<p-tabs value="0">
  <p-tablist>
    <p-tab value="0" i18n>Active Users</p-tab>
    <p-tab value="1" i18n>Client Applications</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel header="Users" value="0">
      <div class="row">
        <div class="col-12 active-user-table">
          @if (loading) {
            <p class="align-content-end" i18n>Loading active users (found <b>{{ total }}</b> so far)</p>
          } @else {
            <p class="align-content-end" i18n>Total active users: <b>{{ total }}</b></p>
          }
          @if (loading && activeSessions.length === 0) {
            <p-table [value]="tempSessions" [tableStyle]="{ 'min-width': '50rem' }">
              <ng-template #header>
                <tr>
                  <th>User ID</th>
                  <th>SSO Ticket ID</th>
                  <th>Dealer Number</th>
                  <th>Distributor Code</th>
                  <th>Client</th>
                  <th>Page</th>
                  <th>Created</th>
                  <th>Expires</th>
                  <th>Accessed</th>
                  <th></th>
                </tr>
              </ng-template>
              <ng-template #body>
                <tr>
                  <td><p-skeleton width="100%" /></td>
                  <td><p-skeleton width="100%" /></td>
                  <td><p-skeleton width="100%" /></td>
                  <td><p-skeleton width="100%" /></td>
                  <td><p-skeleton width="100%" /></td>
                  <td><p-skeleton width="100%" /></td>
                  <td><p-skeleton width="100%" /></td>
                  <td><p-skeleton width="100%" /></td>
                  <td><p-skeleton width="100%" /></td>
                  <td><p-skeleton width="100%" /></td>
                </tr>
              </ng-template>
            </p-table>
          } @else {
            <p-table [value]="activeSessions"
                     [paginator]="false"
                     [loading]="loading"
                     [rows]="1"
                     responsiveLayout="stack"
                     styleClass="p-datatable-striped"
                     aria-label="Active Session Table">
              <ng-template pTemplate="header">
                <tr>
                  <th id="user-id" i18n pSortableColumn="userId" title="ID of the user" aria-label="User ID">User ID
                    <p-sortIcon field="userId"/>
                  </th>
                  <th id="sso-ticket-id" i18n title="Single-Sign-On Ticket ID" aria-label="SSO Ticket ID">SSO Ticket
                    ID
                  </th>
                  <th id="dealer-no" i18n pSortableColumn="dealerNo" title="The Dealer's ID" aria-label="Dealer Number">
                    Dealer No.
                    <p-sortIcon field="dealerNo"/>
                  </th>
                  <th id="distributor-code" i18n pSortableColumn="distributorCode" title="The Distributor's ID"
                      aria-label="Distributor Code">Distr Code
                    <p-sortIcon field="distributorCode"/>
                  </th>
                  <th id="user-client" i18n pSortableColumn="client" title="Users Client" aria-label="Client">Client
                    <p-sortIcon field="client"/>
                  </th>
                  <th id="page" i18n pSortableColumn="page" title="Current Page the User is on" aria-label="Page">Page
                    <p-sortIcon field="page"/>
                  </th>
                  <th id="created" i18n title="When the User Session Began" aria-label="When the User Session Began">
                    Created
                  </th>
                  <th id="expires" i18n title="When the User Session Expires"
                      aria-label="When the User Session Expires">Expires
                  </th>
                  <th id="last-accessed" title="Last time the User accessed the session"
                      aria-label="Users last Accessed">Accessed
                  </th>
                  <th id="endSession" i18n title="Button to end the users session" aria-label="End Session"></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-session>
                <tr>
                  <td i18n-aria-label aria-label="user-id" role="cell">{{ session.userId }}</td>
                  <td i18n-aria-label class="break-word" aria-label="sso-ticket-id"
                      role="cell">{{ session.ssoTicketId }}
                  </td>
                  <td i18n-aria-label aria-label="dealer-no" role="cell">{{ session.dealerNo }}</td>
                  <td i18n-aria-label aria-label="distributor-code" role="cell">{{ session.distributorCode }}</td>
                  <td i18n-aria-label aria-label="client" role="cell">{{ session.client }}</td>
                  <td i18n-aria-label aria-label="page" role="cell">{{ session.page }}</td>
                  <td i18n-aria-label aria-label="created" role="cell">{{ session.createdAt }}</td>
                  <td i18n-aria-label aria-label="expires" role="cell">{{ session.expiresAt }}</td>
                  <td i18n-aria-label aria-label="last-accessed" role="cell">{{ session.lastAccess }}</td>
                  <td>
                    <i class="pi pi-times"
                       aria-label="End users session"
                       tabindex="0"
                       (keyup.space)="endUserSession(session)"
                       (keyup.enter)="endUserSession(session)"
                       (click)="endUserSession(session)"></i>
                  </td>
                </tr>

              </ng-template>
            </p-table>
          }
        </div>
        <p-confirmDialog></p-confirmDialog>
      </div>
    </p-tabpanel>
    <p-tabpanel header="Clients" value="1">
      <div class="row">
        <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3 client-apps-table">
          <p-table [value]="groupedData" [paginator]="false" [responsiveLayout]="'scroll'"
                   styleClass="p-datatable-striped" class="applications-table">
            <ng-template pTemplate="header">
              <tr>
                <th id="client" i18n pSortableColumn="client" title="Users Client" aria-label="User Client Header">
                  Client
                  <p-sortIcon field="client"/>
                </th>
                <th id="users" i18n pSortableColumn="users" title="Number of Users with client"
                    aria-label="Users Header">Users
                  <p-sortIcon field="users"/>
                </th>
                <th id="percentage" i18n pSortableColumn="percentage" title="Percentage of total users with client"
                    aria-label="Percentage header">%
                  <p-sortIcon field="percentage"/>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-group>
              <tr>
                <td i18n-aria-label aria-label="Client" role="cell">{{ group.client }}</td>
                <td i18n-aria-label aria-label="Users" role="cell">{{ group.users }}</td>
                <td i18n-aria-label aria-label="Percentage" role="cell">{{ group.percentage }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
